import React, { FC } from "react";
import { Box, IconButton, TablePagination, TableFooter } from "@mui/material";
import { KeyboardArrowLeft, KeyboardArrowRight } from "@mui/icons-material";

interface TablePaginationActionsProps {
  count: number;
  page: number;
  rowsPerPage: number;
  onPageChange: (
    event: React.MouseEvent<HTMLButtonElement>,
    newPage: number
  ) => void;
}

interface IProps {
  rowsPerPageOptions: any;
  count: number;
  rowsPerPage: number;
  page: number;
  onPageChange?: any;
  onRowsPerPageChange?: any;
  setPage?: any;
}

export const SCUIPagination: FC<IProps> = ({
  count = 0,
  rowsPerPageOptions = [10, 20, 50],
  rowsPerPage = 10,
  page = 0,
  onPageChange,
  onRowsPerPageChange,
  setPage,
}) => {
  function TablePaginationActions(props: TablePaginationActionsProps) {
    const { count, page, rowsPerPage } = props;

    const handleBackButtonClick = () => {
      setPage(page - 1);
    };
    const handleNextButtonClick = () => {
      setPage(page + 1);
    };

    return (
      <Box sx={{ flexShrink: 0, ml: 2.5 }}>
        <IconButton
          onClick={handleBackButtonClick}
          disabled={page === 0}
          aria-label="previous page"
        >
          {" "}
          <KeyboardArrowLeft />
        </IconButton>
        <IconButton
          onClick={handleNextButtonClick}
          disabled={page >= Math.ceil(count / rowsPerPage) - 1}
          aria-label="next page"
        >
          <KeyboardArrowRight />
        </IconButton>
      </Box>
    );
  }

  return (
    <TableFooter>
      <TablePagination
        rowsPerPageOptions={rowsPerPageOptions}
        count={count}
        rowsPerPage={rowsPerPage}
        page={page}
        onPageChange={onPageChange}
        onRowsPerPageChange={onRowsPerPageChange}
        ActionsComponent={TablePaginationActions}
      />
    </TableFooter>
  );
};
